import { useViewerLoading } from '../ViewerLoadingContext';
import styles from './MultiViewerContainer.module.css';

export function TopLoadingBar() {
  const { isAnyPaneLoading } = useViewerLoading();
  if (!isAnyPaneLoading) return null;
  return <div className={styles.topLoadingBar} />;
}
